/**
 * Colorblind-friendly color palette for charts
 * WCAG AA compliant — chromatic series on charcoal admin chrome
 */

export const CHART_COLORS = {
  primary: '#3b82f6',
  secondary: '#22c55e',
  tertiary: '#f59e0b',
  quaternary: '#ef4444',
  quinary: '#a855f7',

  revenue: '#22c55e',
  success: '#10b981',

  orders: '#3b82f6',
  info: '#06b6d4',

  refunds: '#ef4444',
  warning: '#f59e0b',
  danger: '#dc2626',

  background: '#ffffff',
  surface: '#f4f4f5',
  border: '#e4e4e7',

  textPrimary: '#09090b',
  textSecondary: '#52525b',
  textTertiary: '#71717a',
} as const;

/**
 * Get color by index (for chart series)
 */
export function getColorByIndex(index: number): string {
  const colors = [
    CHART_COLORS.primary,
    CHART_COLORS.secondary,
    CHART_COLORS.tertiary,
    CHART_COLORS.quaternary,
    CHART_COLORS.quinary,
  ];
  return colors[index % colors.length] ?? CHART_COLORS.primary;
}

/**
 * Get gradient colors for charts
 */
export function getGradientColors(baseColor: string): { from: string; to: string } {
  const gradients: Record<string, { from: string; to: string }> = {
    [CHART_COLORS.primary]: { from: '#93c5fd', to: '#2563eb' },
    [CHART_COLORS.secondary]: { from: '#4ade80', to: '#22c55e' },
    [CHART_COLORS.tertiary]: { from: '#fbbf24', to: '#f59e0b' },
    [CHART_COLORS.quaternary]: { from: '#f87171', to: '#ef4444' },
    [CHART_COLORS.quinary]: { from: '#d8b4fe', to: '#9333ea' },
  };
  return gradients[baseColor] ?? { from: baseColor, to: baseColor };
}
